import {GeneralLiability as GeneralLiabilityInterface} from "api/policy";
import {Box} from "components/Box";
import {formatAmount} from "utils/format";
import FormTitle from "../components/FormTitle";
import InfoRow from "./InfoRow";

function GeneralLiability({
  generalLiability,
}: {
  generalLiability?: GeneralLiabilityInterface | null;
}) {
  if (!generalLiability) return null;
  return (
    <Box mb={100}>
      <FormTitle.Header>General Liability</FormTitle.Header>
      <InfoRow
        label="Aggregate Limit"
        object={formatAmount(generalLiability.aggregate_limit)}
      />
      <InfoRow
        label="Occurance Limit"
        object={formatAmount(generalLiability.occurrence_limit)}
      />
      <InfoRow
        label="Total Premium"
        object={formatAmount(generalLiability.premium)}
      />
    </Box>
  );
}

export default GeneralLiability;
